import { render } from "./PropertyFileDisplay.vue?vue&type=template&id=bb61eaee&scoped=true&ts=true"
import script from "./PropertyFileDisplay.vue?vue&type=script&lang=ts"
export * from "./PropertyFileDisplay.vue?vue&type=script&lang=ts"

import "./PropertyFileDisplay.vue?vue&type=style&index=0&id=bb61eaee&scoped=true&lang=css"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb61eaee"]])

export default __exports__